// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"890b9c75","165":"62a9bcff","449":"f0518c7f","519":"3d8431b2","539":"fb7a1fef","572":"3e479828","694":"8c170323","810":"8653bace","818":"e5427700"}[chunkId] + ".chunk.js";
};